import { functionsIn } from 'lodash'
import { createStore, useStore, Store } from 'vuex'
import { GlobalState } from '../lib/types'

export default createStore<GlobalState>({
  state: {
    appData: null,
    appErrors: [],
    appLoading: false,
    user: null,
    appViewedList: JSON.parse(sessionStorage.getItem('appViewedList') as string) ?? []
  },

  mutations: {
    appData(state, data) {
      state.appData = data
    },
    user(state, data) {
      state.user = data
    },
    userChangePassword(state) {
      state.user.changePassword = null
    },
    appLoading(state, loading: boolean) {
      state.appLoading = loading
    },
    appErrors(state, data: []) {
      state.appErrors = data
    },
    setAppViewedList(state, data: []) {
      state.appViewedList = data
      sessionStorage.setItem('appViewedList', JSON.stringify(data))
    }
  }
})

export function appLoading(store: Store<GlobalState>, loading: boolean) {
  store.commit('appLoading', loading)
}
